module.exports = __webpack_public_path__ + "assets/img/theme_nemo_large.063c9204.png";